import React from 'react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

const formatDate = (dateString) => {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
  });
};

const getExtColor = (path) => {
  const ext = (path || '').split('.').pop().toLowerCase();
  if (ext === 'md') return 'text-module-identity/70';
  if (ext === 'json') return 'text-yellow-400';
  return 'text-gray-300';
};

const FileCard = ({ file, onClick, showPath = false }) => {
  const name = file.path.split('/').pop();
  return (
    <button
      onClick={() => onClick(file)}
      className="w-full flex items-center gap-3 px-4 py-3 bg-white hover:bg-module-identity/10 transition-colors border-b border-gray-100 last:border-0 text-left"
    >
      <DocumentTextIcon className={`h-6 w-6 flex-shrink-0 ${getExtColor(file.path)}`} />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium text-gray-800 truncate">{name}</p>
        <p className="text-xs text-gray-400 truncate">
          {showPath ? file.path : formatDate(file.updated_at)}
          {showPath && file.updated_at ? ` · ${formatDate(file.updated_at)}` : ''}
        </p>
      </div>
    </button>
  );
};

export default FileCard;
